import { render } from "./OrdersPayment.vue?vue&type=template&id=438f44ea&scoped=true"
import script from "./OrdersPayment.vue?vue&type=script&lang=js"
export * from "./OrdersPayment.vue?vue&type=script&lang=js"

import "./OrdersPayment.vue?vue&type=style&index=0&id=438f44ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438f44ea"]])

export default __exports__